import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { ContentState, convertFromHTML, convertToRaw, EditorState } from 'draft-js';
import useCreateBlogContext from 'contexts/create-blog.context';
import { Input } from '@cokitchen/cokitchen-components';
import draftToHtml from 'draftjs-to-html';

import './styles.scss';
import { useSearchParams } from 'react-router-dom';

const CreateBlogBody = () => {
  const { createBlogForm, setCreateBlogForm, wordsCount } = useCreateBlogContext();
  const [searchParams] = useSearchParams();

  const blogId = searchParams.get('blog_id');
  const [textEditorState, setTextEditorState] = useState<EditorState>();
  const handleEditorStateChange = (e: EditorState) => {
    setTextEditorState(e);
    setCreateBlogForm({
      ...createBlogForm,
      body: JSON.stringify(draftToHtml(convertToRaw(e.getCurrentContent())))
    });
  };
  useEffect(() => {
    if (!blogId || !createBlogForm.body || !!textEditorState) return;

    // To convert back from string to EditorState:
    const htmlString = JSON.parse(createBlogForm.body ?? '');
    const blocksFromHTML = convertFromHTML(htmlString);
    const editorState = EditorState.createWithContent(
      ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)
    );
    setTextEditorState(editorState);
  }, [blogId, createBlogForm.body]);

  return (
    <div>
      <Input
        label='Article title'
        small
        value={createBlogForm.title}
        className='mb-4'
        onChange={(e) => setCreateBlogForm({ ...createBlogForm, title: e.target.value })}
      />

      <p className='mb-2 font-medium'>Article Body</p>
      <>
        <Editor
          editorState={textEditorState}
          toolbarClassName='toolbarClassName'
          wrapperClassName='wrapperClassName'
          editorClassName='editorClassName '
          onEditorStateChange={handleEditorStateChange}
          placeholder="You Know how you buy a really awesome gift for someone and you're just so excited out of your shoes for the person to experience it? 🤭 Think that, think Red Pepper! 🌶️📸
with ❤️"
        />
        {(() => {
          if (!textEditorState) return null;

          if (wordsCount < 100) {
            return (
              <div className='text-red-500 text-xs mt-2'>
                Article body must be at least 100 words. Current:{' '}
                <span className={'text-red-5'}> {wordsCount}</span> word
                {wordsCount !== 1 ? 's' : ''}
              </div>
            );
          }
          return null;
        })()}
      </>
      <Input
        label='Pin Post'
        type='checkbox'
        small
        checked={createBlogForm.pinPost}
        className='mt-6'
        onChange={(e) => setCreateBlogForm({ ...createBlogForm, pinPost: e.target.checked })}
      />
    </div>
  );
};

export default CreateBlogBody;
